import {useEffect} from 'react';

import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';
import {loadDocumentSeriesList, SeriesTypeEnum, useThunkDispatch} from '@dms/teas';

import {CustomerSeriesDefinitionList} from './components/CustomerSeriesDefinitionList';

export function CustomerCodeDefinition() {
  const dispatch = useThunkDispatch();

  useEffect(() => {
    dispatch(
      loadDocumentSeriesList({
        type: [SeriesTypeEnum.GENERAL_CUSTOMER],
        config: {sendBranch: false},
      })
    );
  }, [dispatch]);

  return (
    <SettingsTemplate
      header={{title: i18n.t('entity.seriesDefinition.labels.customerCodeDefinition')}}
      data-testid="integrations-customer-definitions-settings-modal"
      description={i18n.t('entity.seriesDefinition.labels.customerDefinitionDescription')}
    >
      <CustomerSeriesDefinitionList />
    </SettingsTemplate>
  );
}
